.cancel-discount {
  &__abort-link {
    color: var(--sc-color-gray-500);
  }
}
